/** PRO PARTS wordmark (text-based placeholder until the official logo files are provided). */
export function Logo({ className = '' }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} dir="ltr">
      <svg viewBox="0 0 52 52" className="h-9 w-9 shrink-0 drop-shadow-[0_10px_18px_rgb(0_0_0/0.45)]" aria-hidden>
        <path d="M3 3h34l12 12v34H3z" fill="#0f1318" stroke="#353e4a" />
        <path d="M3 3h34l12 12" fill="none" stroke="#2e8bff" strokeWidth="2" />
        <path d="M12 39V13h13.4c7 0 11.1 3.5 11.1 9.1 0 5.8-4.1 9.3-11.1 9.3h-5.9V39H12Zm7.5-13.9h5.3c2.8 0 4.3-1 4.3-3s-1.5-2.9-4.3-2.9h-5.3v5.9Z" fill="#e6eaf0" />
        <path d="m37 18 5-3-5 24h-6z" fill="#2e8bff" />
        <circle cx="43.5" cy="42.5" r="2" fill="#82bdff" />
      </svg>
      <span className="keep-tracking flex items-center font-[Barlow_Condensed] text-[1.22rem] leading-none font-bold tracking-[0.15em] text-white">
        PRO <span className="ms-1.5 text-volt-400">PARTS</span>
      </span>
    </span>
  );
}
